// @flow

import type { SalesMember } from 'statsradio/modules/salesMembers/domain/SalesMember';

export const CampaignStatusFilter = {
  NO_FILTER: 'NO_FILTER',
  NOT_COMPLETED: 'NOT_COMPLETED',
  NOT_LINKED: 'NOT_LINKED',
};
export type CampaignStatusFilterOptions = $Values<typeof CampaignStatusFilter>;


export const SELECT_ALL_SALES_MEMBERS = 'SELECT_ALL_MEMBERS';

export type CampaignFiltersParameters = {
  filterBy?: CampaignStatusFilterOptions;
  searchText?: string;
  salesMember?: SalesMember;
}

const DEFAULT_CAMPAIGN_FILTERS_PARAMETERS = {
  filterBy: CampaignStatusFilter.NO_FILTER,
  searchText: '',
  salesMember: SELECT_ALL_SALES_MEMBERS,
};

export default class CampaignFilters {
  filterBy: CampaignStatusFilterOptions;
  searchText: string;
  salesMember: SalesMember;

  constructor({ filterBy, searchText, salesMember }: CampaignFiltersParameters) {
    this.filterBy = filterBy || DEFAULT_CAMPAIGN_FILTERS_PARAMETERS.filterBy;
    this.searchText = searchText || DEFAULT_CAMPAIGN_FILTERS_PARAMETERS.searchText;
    this.salesMember = salesMember || DEFAULT_CAMPAIGN_FILTERS_PARAMETERS.salesMember;
  }

  with({ filterBy, searchText, salesMember }: CampaignFiltersParameters) {
    return new CampaignFilters({
      filterBy: filterBy || this.filterBy,
      searchText: typeof searchText === 'undefined' ? this.searchText : searchText,
      salesMember: salesMember || this.salesMember,
    });
  }

  static default() {
    return new CampaignFilters(DEFAULT_CAMPAIGN_FILTERS_PARAMETERS);
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/campaigns/domain/CampaignV2Filters.js